import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  contentBox: {
    maxHeight: "354px",
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(6),
    marginBottom: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      margin: 0,
      marginBottom: theme.spacing(2),
    },
  },
  boxImg: {
    marginBottom: theme.spacing(2),
  },
  marginImg: {
    marginRight: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      marginRigth: 0,
    },
  },
  label: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 500,
  },
  select: {
    marginTop: "6px",
  },
  content: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(40),
  },
  titleSpacing: {
    marginTop: theme.spacing(2),
  },
  whiteFont: {
    color: "#fff",
  },
  textCenter: {
    [theme.breakpoints.down("md")]: {
      textAlign: "center",
    },
  },
  darkFont: {
    color: theme.palette.action.main,
  },
  justOneContentBox: {
    display: "flex",
    alignItems: "center",
    maxWidth: "100%",
    borderRadius: theme.shape.borderRadius,
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(4),
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  },
  placeholder: {
    "& input": {
      color: theme.palette.text.disabled,
    },
  },
}));

export default useStyles;
